package app.nestbridge.domain.identity.usecase

import app.nestbridge.domain.identity.model.UserProfile
import app.nestbridge.domain.identity.service.UserProfileService
import me.tatarka.inject.annotations.Inject

@Inject
class SaveUserProfileUseCase(
    private val userProfileService: UserProfileService,
) {
    suspend operator fun invoke(profile: UserProfile): UserProfile = userProfileService.save(profile)
}
